import { Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { User } from "@thalamos/haven-common";

import { useUser } from "../../Context/UserContext.js";

export const HomePage = () => {
  const { user } = useUser();

  return <HomePageContent user={user} />;
};

/**
 * The page's rendering, with the signed-in user injected rather than reached for
 * through context, so a story can show it against a user it chose.
 *
 * Takes `User` rather than `CurrentUser`: this page says who someone is and
 * nothing about what they may do, and the narrower type keeps it that way.
 */
export const HomePageContent = ({ user }: { user: User | undefined }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={3} sx={{ maxWidth: 720 }}>
      <Typography variant="h4" component="h1">
        {t("home.title")}
      </Typography>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Stack spacing={1}>
          <Typography variant="overline" color="text.secondary">
            {t("auth.signedInAs")}
          </Typography>
          <Typography variant="h6" component="p">
            {user?.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user?.email}
          </Typography>
        </Stack>
      </Paper>
      <Typography variant="body2" color="text.secondary">
        {t("home.noAssessments")}
      </Typography>
    </Stack>
  );
};
